import React from "react";
import useMostPopularExtras from "../../../../hooks/shared/extras/useMostPopularExtras";
import * as Flex from "../../../../../../../common-deprecated/styles/v2/lexus/globals/Flex";
import * as Styles from "./styles/MostPopular";
import * as PackStyles from "./styles/Pack";
import Extra from "../../common/extras/Extra";
import { BnbLabel, useBnbOptionalLabel } from "../../../../utils/labels";
import Popover from "../../../../../../../common-deprecated/components/popover/aem/lexus/Popover";

const MostPopularExtras = (): JSX.Element | null => {
    const { mostPopularExtras, modelName, onAddExtra, onRemoveExtra, onSetExtraOption } = useMostPopularExtras();
    const wltpPopupText = useBnbOptionalLabel("T1.disclaimerWltpShort");

    if (!mostPopularExtras.length) return null;

    return (
        <Flex.Row>
            <Flex.Col width={1}>
                <Styles.Title>
                    <BnbLabel label="mostPopularTitle" />
                    {wltpPopupText && <Popover showOnClick content={wltpPopupText} />}
                </Styles.Title>
                <Styles.Description>
                    <BnbLabel label="mostPopularIntroText" params={{ model: modelName }} />
                </Styles.Description>
            </Flex.Col>
            <Flex.Col width={1} mt={4}>
                <PackStyles.Grid>
                    {mostPopularExtras.map((item) => (
                        <Extra
                            optional
                            enabled
                            key={item.extra.id}
                            extra={item.extra}
                            equipped={item.checked}
                            equippedOptionId={
                                item.checked && item.extra.selectedOptionId ? item.extra.selectedOptionId : ""
                            }
                            onSelect={() => {
                                if (item.checked) onRemoveExtra(item.extra);
                                else onAddExtra(item.extra);
                            }}
                            onOptionSelect={(optionId: string) => onSetExtraOption(item.extra, optionId)}
                        />
                    ))}
                </PackStyles.Grid>
            </Flex.Col>
        </Flex.Row>
    );
};

export default MostPopularExtras;
